import { RequestValidator } from 'App/axiosUtils/requestValidation';
import { USER_PASSWORD_CHANGE_REQUIRED_ENABLED } from 'App/featuresFlags';
import { useGetTags, useIsLogged } from 'domains/Auth/hooks';
import Amplitude from './Amplitude';
import GoogleAnalytics from './GoogleAnalytics';
import RequirePasswordReset from './RequirePasswordReset';
import { Satismeter } from './Satismeter';
import Userflow from './Userflow';

function ExternalServices() {
  const { isLogin } = useIsLogged();
  const tags = useGetTags();
  const hasRequirePasswordResetTag = tags.includes(
    USER_PASSWORD_CHANGE_REQUIRED_ENABLED,
  );

  return (
    <>
      {isLogin && <Amplitude />}
      {isLogin && <Userflow />}
      {isLogin && hasRequirePasswordResetTag && <RequirePasswordReset />}
      <RequestValidator />
      <GoogleAnalytics />
      {isLogin && <Satismeter />}
    </>
  );
}

export default ExternalServices;
